import {combineReducers} from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './authUser/reducer';
import advisers from './advisers/reducer';


const reducers = combineReducers({
  menu,
  settings,
  authUser,
  advisers
});

export default reducers;
